import React from 'react';
import Footer from '../components/Footer';

export default function AboutView() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] flex flex-col items-center justify-between text-gray-200">
      <div className="grow flex flex-col items-center justify-start w-full px-4 py-12">
        <div className="w-full max-w-4xl prose prose-invert prose-blue">

          <h1>About SnipIT</h1>
          <p>SnipIT is a developer enablement platform built by DevIT Systems. Our mission is to provide independent developers and enterprise organizations with a unified, secure, and cross-platform vault for snippets, knowledge, and tools.</p>
          <p>We believe that developers should have seamless access to their knowledge base whether they are working in the browser, on the desktop, or inside the IDE.</p>

          <h2>Contact the Developer</h2>
          <p>Have questions, feedback, or need support? Connect with the developer directly through the Contact page.</p>
          <p><a href="https://www.snipit.devitsystems.com/contact"><strong>Go to the SnipIT Contact Page &rarr;</strong></a></p>

        </div>
      </div>
      <Footer />
    </div>
  );
}
